import { createFileRoute } from "@tanstack/react-router";
import { useEffect, useState } from "react";

import { AuthShell } from "@/components/auth/auth-shell";
import { ForgotForm } from "@/components/auth/forgot-form";
import { pb } from "@/lib/pb";
import { DEFAULT_BRAND, type TenantBrand, resolveTenantBrand } from "@/lib/tenant-brand";
import { useDocumentTitle } from "@/lib/use-document-title";

export const Route = createFileRoute("/forgotpwd")({
  component: ForgotPwdPage,
});

function ForgotPwdPage() {
  useDocumentTitle("Forgot password");

  const [brand, setBrand] = useState<TenantBrand>(DEFAULT_BRAND);
  useEffect(() => {
    setBrand(resolveTenantBrand(window.location.host));
  }, []);

  async function handleSubmit(email: string) {
    // PB returns the same shape regardless of whether the email exists
    // — by design, to avoid leaking which addresses are registered. The
    // form shows "Check your inbox" either way.
    await pb.collection("auth").requestPasswordReset(email);
  }

  return (
    <AuthShell brand={brand}>
      <ForgotForm onSubmit={handleSubmit} />
    </AuthShell>
  );
}
